import { axiosInstance } from '@/shared/api/axiosInstance';
import { useLogin } from './useLogin';
import axios from 'axios';

export const useRegister = () => {
    const { login } = useLogin();

    const register = async (formData: {
        lastName: string;
        firstName: string;
        middleName?: string;
        birthDate: string;
        phone: string;
        email: string;
        policyNumber: string;
        password: string;
    }): Promise<{ success: true } | { success: false; error: string }> => {
        try {
            const payload = {
                surname: formData.lastName,
                first_name: formData.firstName,
                second_name: formData.middleName || null,
                birth_date: formData.birthDate,
                email: formData.email,
                password: formData.password,
                insurance_company: 'soglasie',
                policy_number: formData.policyNumber,
            };

            const response = await axiosInstance.post('/auth/register', payload);
            console.log('Регистрация успешна:', response.data);

            await login(formData.email, formData.password);
            return { success: true };
        } catch (error: any) {
            let message = 'Произошла ошибка при регистрации';
            if (axios.isAxiosError(error)) {
                message = error.response?.data?.detail || message;
            }
            console.error('Ошибка регистрации:', message);
            return { success: false, error: message };
        }
    };

    return { register };
};
